'use strict';

var util = require('./../util'),
    dialog = require('./../dialog'),
    internationalshipping = require('../internationalshipping');
var header ={
    init : function() {
            // SC-8803 - Capture scroll event if in iPhone keyboard opens up on search bar
            $(window).on("scroll",function(){
                if($(window).width() < 768 && $("body").hasClass("right-panel-open")){
                    if(window.rightPanelTimeout){
                        clearTimeout(window.rightPanelTimeout);
                    }
                    window.rightPanelTimeout = setTimeout(function(){
                        $(window).trigger("resize.rightPanel");
                    }, 100);
                }
            });
            // WCAG - Accout flyout
            $("body").on("keyup", ".secondary-account a.account-btn, .cart-sign-in-cta ", function(e){
                if(e.keyCode === 13){
                    var $this = $(this);
                    e.preventDefault();
                    util.trapFocus($('.right-panel-pane-login.active'), function(){
                        $this.focus().addClass('focus-outline');
                        $('.secondary-account').removeClass('has-active-panel');
                        $('body').removeClass('right-panel-open');
                    })          
                }
            });

            $("body").on("keyup", ".header-search-util a", function(e){
                if(e.keyCode === 13){
                    e.preventDefault();
                    util.trapFocus($('.right-panel-pane-search.active'), function(){
                        $('.header-search-util a').focus().addClass('focus-outline');
                        $('.header-search-util.has-active-panel').removeClass('has-active-panel');
                        $('body').removeClass('right-panel-open');
                    })          
                }
            });

            $("body").on("keyup", ".secondary-card a.flyout", function(e){
                if(e.keyCode === 13){
                    e.preventDefault();
                    util.trapFocus($('.right-panel-pane-card.active'), function(){
                        $('.secondary-card a.flyout').focus().addClass('focus-outline');
                        $('.secondary-card.has-active-panel').removeClass('has-active-panel');
                        $('body').removeClass('right-panel-open');
                    })          
                }
            });

            $('body').on('keyup', '.flyout-cart a', function(e){
                if(e.keyCode === 9){
                    e.preventDefault();
                    $('.right-panel-pane-search, .right-panel-pane-login, .right-panel-pane-card').removeClass('active');
                    $(this).closest('.flyout-cart').addClass('has-active-panel');
                    $('body').addClass('right-panel-open');
                    var topPos = header.getRightPanelPlacement();
                    $('.right-panel').css('top', topPos).css('height',  $(window).height()-topPos);
                    $('.right-panel-pane-cart').addClass('active');
                    util.trapFocus($('.right-panel-pane-cart.active'),function(){
                        $('body').removeClass('right-panel-open');
                        $('.flyout-cart.has-active-panel').removeClass('has-active-panel');        
                        $('.right-panel-pane-cart').removeClass('active');
                        $('.secondary-header .flyout-cart a').focus().addClass('focus-outline');
                    });
                }
            });            

            $('body').on('blur', '.right-panel-pane-login .login-box .username input:visible', function (e) {
                if(!$(this).val().length) {           
                    $(this).closest('.form-row').siblings('.reset-error-caption.email-valid').addClass('hide');
                    $(this).closest('.form-row').siblings('.reset-error-caption.username-req').removeClass('hide');
                    $(this).closest('.form-row').siblings('.reset-error-caption.email-valid').attr('id', 'email_error_na');
                    $(this).closest('.form-row').siblings('.reset-error-caption.username-req').attr('id', 'email_error');
                }     
            });

            //The following function was copied to app_custom_fbb/cartridge/client/default/js/components/header.js
            //sign-in ajax
            $('.clickbutton button').on('click', function (e) {
                var isKeyEnter = window.lastClickOrKey === 'key' ? true : false;
                e.preventDefault();
                var $headerLoginForm = $(this).closest('form');
                if (!$headerLoginForm.valid()) {
                    $('.right-panel-pane-login .login-box-content input.error').first().focus();
                    if(isKeyEnter){
                        $('.right-panel-pane-login .login-box-content input.error').first().addClass('focus-outline');
                    }
                    return false;
                }       
            
                var frametimer = "";
                var iframeId = 'js-flyOut-signin-iframe';
                var formId = 'js-flyOut-signin-form';
                jQuery('#' + iframeId).remove();
                jQuery('#' + formId).remove();
                var $form = jQuery('<form></form>');
                $form.attr('id', formId);
                $form.attr('action', $headerLoginForm.attr('action'));
                $form.attr('target', iframeId);
                $form.attr('method', 'POST');
                jQuery('<iframe name="' + iframeId + '" id="' + iframeId + '" />').appendTo('body');
                jQuery('#' + iframeId).attr('style', 'display: none;');
                $headerLoginForm.find('input, select, textarea, button').each(function () {
                    var $input = $(this).clone();
                    $form.append($input);
                });
                $("<input/>").attr({ id: "request-type", type: "hidden", name: $(this).attr("name"), value: $(this).attr("value") }).appendTo($form);
                frametimer = setInterval(function () {
                    if (jQuery('#' + iframeId).contents().find('body').length === 1) {
                        clearTimeout(frametimer);
                        jQuery('#' + iframeId).contents().find('body').append($form);
                        jQuery('#' + iframeId).contents().find('form').submit();
                    }
                }, 500);
            });
            $('body').on('touchstart click','.mini-cart-content .minicart-checkout-button',function(){
                var globaleCookie = util.getCookie('GlobalE_Data').length ? JSON.parse(decodeURIComponent(util.getCookie('GlobalE_Data'))) : '';
                var globaleCookieCountry = globaleCookie && globaleCookie.countryISO;
                var geExcludedCountries = SitePreferences.GLOBALE_EXCLUDED_COUNTRIES;
                if(globaleCookieCountry && geExcludedCountries && geExcludedCountries.toLowerCase().indexOf(globaleCookieCountry.toLowerCase()) == -1){
                    internationalshipping.directCheckoutInternationalFunc();
                }else{
                    window.location.href = Urls.directCheckout;
                }
                return false;
            });

       
            this.detectOS();
            this.mobileComponentPlacement();
            this.disableScrollForiOSRightPanel();
            this.browserDetectChrome();
    },

    getRightPanelPlacement : function () {
        var top = 0;
        var isMobileStickyHeaderActive = $('body').hasClass('header-sticky-mobile');
        if($(window).width() > 767){
        	top = $(window).width() > 1023 && $("body").hasClass("header-sticky-desktop") ? (($(".slider-menu #navigation").offset().top - $(window).scrollTop()) + $(".slider-menu #navigation").height()) : ($(".secondary-header:visible > ul").offset().top - $(window).scrollTop()) + $(".secondary-header:visible > ul").height();
        } else {
        	top = isMobileStickyHeaderActive ? ($(".secondary-header:eq(2) > ul").offset().top - $(window).scrollTop()) + $(".secondary-header:eq(2) > ul").height() : ($("body").hasClass("header-mobile-menu-open") ? $("#navigation .navigation-header-wrapper").offset().top + $("#navigation .navigation-header-wrapper").outerHeight() : $(".secondary-header:eq(2) > ul").position().top + $(".secondary-header:eq(2) > ul").height());
        }
        return top;
    },

    mobileComponentPlacement: function(){
        var scrollWrapper = $(".top-menu-utility-wrapper .brands-header");
        if(scrollWrapper.length){
            $(window).on("resize load", function(){                
                if(scrollWrapper.find(".brands-carousel").length == 0){
                    var ribbonClone = scrollWrapper.find(">ul").clone();
                    ribbonClone.find("li").not(".brands-header-item-inactive").remove();
                    ribbonClone.prependTo(scrollWrapper);
                    scrollWrapper.find(">ul:first-child").wrap("<div class='brands-carousel jcarousel'></div>");
                    var startX = 0;
                    var initialUlLeft = 0;
                    setTimeout(function(){
                        scrollWrapper.find(".brands-carousel").on('jcarousel:create jcarousel:reload', function() {
                            var carouselItemWidth = ($(window).innerWidth() > 767 && $(window).innerWidth() < 1024) ? $(this).innerWidth()/8 : $(this).innerWidth()/5;
                            $(this).jcarousel('items').css('width', carouselItemWidth + 'px');
                        }).jcarousel({wrap: 'circular', items: '.brands-header-item'});
                        var addedOffsetLeft = 0;
                        var addedOffsetRight = 0;
                        var reelUL = scrollWrapper.find(".brands-carousel > ul");                                                                                          
                        var lastChild = reelUL.find("> li:last-child"); 
                        var firstChild = scrollWrapper.find(".brands-carousel > ul > li:first-child");
                        var lastChildWidth = lastChild.width();
                        scrollWrapper.find(".brands-carousel")[0].addEventListener("touchstart", function(e){
                            startX = e.changedTouches[0].pageX;
                            initialUlLeft = reelUL.position().left;
                            addedOffsetLeft = addedOffsetRight = 0;
                        }, {passive: false});                   
                        scrollWrapper.find(".brands-carousel")[0].addEventListener("touchmove", function(e){
                            e.preventDefault();                            
                            var calcLeft = 0;
                            var ePageX = e.changedTouches[0].pageX;                        
                            if(startX > ePageX){
                                calcLeft = initialUlLeft - (startX - ePageX);
                            }else{
                                calcLeft = initialUlLeft + (ePageX - startX);
                            }                                                          
                            if(scrollWrapper.find(".brands-carousel > ul").offset().left > -(lastChildWidth)){ 
                                lastChild = reelUL.find("> li:last-child");                               
                                addedOffsetLeft += lastChildWidth;
                                reelUL.prepend(lastChild);
                            }
                            if((reelUL.find("> li:last-child").offset().left + lastChildWidth) < (window.innerWidth + lastChildWidth)){
                                firstChild = scrollWrapper.find(".brands-carousel > ul > li:first-child");
                                addedOffsetRight += lastChildWidth;
                                reelUL.append(firstChild);
                            }
                            reelUL[0].style.left = ((calcLeft - addedOffsetLeft) + addedOffsetRight) + "px";                                                                   
                        }, {passive: false});
                        scrollWrapper.find(".brands-carousel")[0].addEventListener("touchend", function(ev){
                            for(var i=0; i<6; i++){
                                setTimeout(function(){
                                    var e = new Event('touchmove');
                                    e.changedTouches = [{pageX: ev.changedTouches[0].pageX}]
                                    $(".brands-carousel")[0].dispatchEvent(e);                               
                                }, i + 1);
                            }
                        });
                        var firstActiveItem = scrollWrapper.find(".brands-header-active").next("li.brands-header-item").length ? scrollWrapper.find(".brands-header-active").next("li") : scrollWrapper.find(".brands-header-active-mobile").next("li");
                        scrollWrapper.find(".brands-carousel > ul > li").each(function(){
                            if($(this).attr("class") === firstActiveItem.attr("class")){
                                $('.brands-carousel').jcarousel('scroll', $(this).prevAll("li").length - 1);
                            }
                        });
                    }, 500);                    
                }
            });
        }
    },

    disableScrollForiOSRightPanel: function(){
        // Disable Scroll For iOS in case of right panel open
        if($("html").hasClass("ios-os")){
            document.body.addEventListener("touchmove", function(e){
                if($("body").hasClass("right-panel-open") && !$("body").hasClass("header-mobile-menu-open") && !$('.right-panel-pane-card').hasClass('active')){
                    e.preventDefault();
                }
            }, { passive: false });
            $("body").on("blur", ".right-panel .simpleSearch input#q", function(){
                if($(window).height() < 400 && $(".right-panel").hasClass("p-absolute") && $(window).width() < 768){
                    $("html, body").scrollTop(0);
                }
            });
            $('.header-search button').on("touchend", function (e) {
                if($(window).height() < 400 && $(".right-panel").hasClass("p-absolute") && $(window).width() < 768){
                    e.preventDefault();
                    $("html, body").scrollTop(0);
                    setTimeout(function(){
                        if(header.validateSearchField()){
                            $('.header-search form')[0].submit(); 
                        }
                    }, 500);             
                }
            });
        }
    },

    validateSearchField: function(){
        if (!$('.header-search').hasClass('focus')) {
            $('.header-search .simplesearch').addClass('fixed-active');
            $('.header-search').addClass('search-button');
            $('.header-search').toggleClass('focus');
            $('.quick-order').toggleClass('quick-order-focus');
            $('.top-banner').toggleClass('header-search-button');
            	if ($('.simplesearch input[type="text"]').val() == '' || $('.simplesearch input[type="text"]').val() === $('.header-search .simplesearch').find('input[type="text"]').attr('placeholder')) {
            		return false; // to prevent redirection on desktop if empty
            	}else{
            		return true; // if the input field filled and collapsed
            	}            	
        } else if ($('.simplesearch input[type="text"]').val() == '' || $('.simplesearch input[type="text"]').val() === $('.header-search .simplesearch').find('input[type="text"]').attr('placeholder')) {
            $('.header-search .simplesearch').removeClass('fixed-active'); 
            $('.header-search').removeClass('search-button');
            $('.header-search').toggleClass('focus');
            $('.quick-order').toggleClass('quick-order-focus');
            $('.top-banner').toggleClass('header-search-button');
            return false;
        } else {
            return true;
        }
    },

    detectOS: function(){
        // Detecting MAC OSx
        if(navigator.platform.indexOf("Mac") > -1){
            $("html").addClass("mac-os");
        }
        // Detect iOS devices
        if(['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0){
            $("html").addClass("ios-os");
        }
    }, 
    browserDetectChrome : function(){
        $(window).on("resize load", function(){                
            var isChrome = navigator.userAgent.includes("Chrome") && navigator.vendor.includes("Google Inc");
            if(isChrome){
                $('body').addClass('browser-chrome');                    
            }                
        });
    }
}

module.exports = header;